/**
 * Lead Assignment Tour Configuration
 * Introduces agency owners and admins to lead assignment features
 */

import { TourDefinition } from './tour.types';

export const leadAssignmentTour: TourDefinition = {
  id: 'lead-assignment-tour',
  name: 'Lead Assignment',
  page: '/lead-assignment',
  version: 7, // Added tab navigation with onShow callbacks
  requiresAgency: true, // Only for agency owners/admins
  allowedAgencyRoles: ['owner', 'admin', 'agency_owner'],
  nextTourId: 'dialer-tour', // Chain to dialer tour
  steps: [
    {
      id: 'assignment-intro',
      targetSelector: '[data-tour="assignment-header"]',
      title: 'Lead Assignment Center',
      description:
        'Distribute leads to your team efficiently! Assign leads manually or set up automatic distribution rules.',
      placement: 'bottom',
    },
    {
      id: 'assignment-tabs',
      targetSelector: '[data-tour="assignment-tabs"]',
      title: 'Assignment Tabs',
      description:
        'Navigate between different views: Dashboard for assigning leads, Status Overview for tracking progress, and Activity for recent actions.',
      placement: 'bottom',
    },
    {
      id: 'unassigned-leads',
      targetSelector: '[data-tour="unassigned-leads"]',
      title: 'Unassigned Leads',
      description:
        'These leads are waiting to be assigned to an agent. Review them and assign based on agent availability, expertise, or territory.',
      placement: 'right',
    },
    {
      id: 'agent-selector',
      targetSelector: '[data-tour="agent-selector"]',
      title: 'Agent Workload',
      description:
        'See each agent\'s current workload and performance. Assign leads to agents based on their availability and capacity.',
      placement: 'left',
    },
    {
      id: 'status-tab',
      targetSelector: '[data-tour="assignment-tab-status"]',
      title: 'Status Overview',
      description:
        'This tab shows the status breakdown of all assigned leads. Track how leads progress through your sales pipeline.',
      placement: 'bottom',
      onShow: () => {
        // Click the status tab to show its content
        setTimeout(() => {
          const tab = document.querySelector('[data-tour="assignment-tab-status"]') as HTMLElement;
          if (tab) {
            tab.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
            tab.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
            tab.click();
          }
        }, 50);
      },
    },
    {
      id: 'activity-tab',
      targetSelector: '[data-tour="assignment-tab-activity"]',
      title: 'Activity Feed',
      description:
        'View recent assignment activity and history. See who assigned what leads and track all changes made to assignments.',
      placement: 'bottom',
      onShow: () => {
        // Click the activity tab to show its content
        setTimeout(() => {
          const tab = document.querySelector('[data-tour="assignment-tab-activity"]') as HTMLElement;
          if (tab) {
            tab.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
            tab.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
            tab.click();
          }
        }, 50);
      },
    },
  ],
};
